import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useState } from 'react'
import TagManager from 'react-gtm-module'
import { useTranslation } from 'react-i18next'

import cashier_icon from '../../assets/profile/cashier_icon.svg'
import claim_history_white_icon from '../../assets/profile/claim_history_white_icon.svg'
import deposit_icon from '../../assets/profile/deposit_icon.svg'
import financial_icon from '../../assets/profile/financial_icon.svg'
import transactions_icon from '../../assets/profile/transactions_icon.svg'
import withdraw_icon from '../../assets/profile/withdraw_icon.svg'
import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import LoginModal from '../common/log-in-modal'
import Icon from '../icon'

type CashierProps = {
  closeProfileDrawer: () => void
}

const Cashier = ({ closeProfileDrawer }: CashierProps) => {
  const username = useBoundStore(state => state.user.username)
  const logInModal = useModal(LoginModal)
  const { geoCheck } = useGeoCheck()
  const { t } = useTranslation(['drawer', 'walletManagement'])
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className="transition-all duration-[0.2s] ease-[ease-in-out] overflow-hidden"
      style={{ height: isOpen ? '241px' : '44px' }}>
      <div
        className="flx-btw-ctr px-5 py-3"
        onClick={() => setIsOpen(prev => (prev ? false : true))}>
        <div className="flx-str-ctr">
          <div className="flx-str-ctr" style={{ width: '40px' }}>
            <img
              className="max-w-[25px] max-h-[25px]"
              src={cashier_icon}
              alt="Cashier"
            />
          </div>
          <span className="text-xs font-Syncopate-Bold uppercase text-txt">
            {t('cashier', { ns: 'drawer' })}
          </span>
        </div>
        <Icon
          className="transition-all duration-[0.2s] ease-[ease-in-out]"
          id="triangle-left"
          width="10"
          height="21"
          fill="#DF0033"
          style={{ transform: `rotate(${isOpen ? '-90' : '0'}deg)` }}
        />
      </div>
      <div style={{ padding: '4px 0px 4px 60px', backgroundColor: '#DF0033' }}>
        <span
          className="flx-str-ctr px-0 py-2 last:border-0"
          onClick={() => {
            closeProfileDrawer()
            if (!username) {
              return geoCheck(logInModal.show)
            }
            TagManager.dataLayer({
              dataLayer: {
                event: 'deposit_form_open',
                event_category: 'deposit_funds',
                event_action: 'click_open',
                event_label: 'Deposit form Open',
                user_id: username,
              },
            })
            window.open(`${location.origin}/deposit`, 'blank')
          }}>
          <div className="flx-str-ctr w-[30px]">
            <img
              className="max-w-[20px] max-h-5"
              src={deposit_icon}
              alt="Deposit"
            />
          </div>
          <span className="text-sm text-white">
            {t('deposit', { ns: 'walletManagement' })}
          </span>
        </span>
        <span
          className="flx-str-ctr px-0 py-2 last:border-0"
          onClick={() => {
            closeProfileDrawer()
            if (!username) {
              return geoCheck(logInModal.show)
            }
            window.open(`${location.origin}/withdraw`, 'blank')
          }}>
          <div className="flx-str-ctr w-[30px]">
            <img
              className="max-w-[20px] max-h-5"
              src={withdraw_icon}
              alt="Withdraw"
            />
          </div>
          <span className="text-sm text-white">
            {t('withdrawal', { ns: 'walletManagement' })}
          </span>
        </span>
        <Link to={username ? '/profile/transaction-history' : undefined}>
          <span
            className="flx-str-ctr px-0 py-2 last:border-0"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <div className="flx-str-ctr w-[30px]">
              <img
                className="max-w-[20px] max-h-5"
                src={transactions_icon}
                alt="Transactions"
              />
            </div>
            <span className="text-sm text-white">
              {t('transactions', { ns: 'drawer' })}
            </span>
          </span>
        </Link>
        <Link
          to={username ? '/profile/financial-transaction' : undefined}
          search={{ tab: 'all' }}>
          <span
            className="flx-str-ctr px-0 py-2 last:border-0"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <div className="flx-str-ctr w-[30px]">
              <img
                className="max-w-[20px] max-h-5"
                src={financial_icon}
                alt="Financial Transactions"
              />
            </div>
            <span className="text-sm text-white">
              {t('financial-transactions', { ns: 'drawer' })}
            </span>
          </span>
        </Link>
        <Link to={username ? '/profile/claim-history' : undefined}>
          <span
            className="flx-str-ctr px-0 py-2 last:border-0"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <div className="flx-str-ctr w-[30px]">
              <img
                className="max-w-[20px] max-h-5"
                src={claim_history_white_icon}
                alt="Financial Transactions"
              />
            </div>
            <span className="text-sm text-white">{t('claim-history')}</span>
          </span>
        </Link>
      </div>
    </div>
  )
}

export default Cashier
